export default {
  title: {
    create: 'Nowy sygnał wirtualny',
    edit: 'Ustawienia sygnału',
  },
  tabs: {
    signal: 'Ustawienia sygnału wirtualnego',
    preset: 'Ustawienia wstępne',
    metadata: 'Ustawienia sygnału',
  },
};
